/**
 * Control Centre UI feature flags.
 *
 * Info / HelpCircle tooltips (KPI score formulas, System Health score help)
 * are preserved in component source but hidden in the UI when this is false.
 * Set to true to restore the icons without re-adding tooltip content.
 */
export const SHOW_CONTROL_CENTRE_INFO_TOOLTIPS = false;
